/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Button, Stack, Text } from "@carrotfertility/carotene"
import { CaseRateRenewalModalTopSection } from "./CaseRateRenewalModalTopSection"
import { CaseRateRenewalModalButtonGroup } from "./CaseRateRenewalModalButtonGroup"
import { FormattedMessage, useIntl } from "react-intl"

type DoneForNowContentProps = {
  showBack: boolean
  takeMeBackOnClick: () => void
  yesImDoneOnClick: () => void
  isLoading: boolean
}

export function DoneForNowContent({
  showBack,
  takeMeBackOnClick,
  yesImDoneOnClick,
  isLoading
}: DoneForNowContentProps): JSX.Element {
  const intl = useIntl()

  return (
    <>
      <CaseRateRenewalModalTopSection
        header={intl.formatMessage({
          defaultMessage: "Are you sure you're done using Carrot?"
        })}
        showImage
        showBack={showBack && !isLoading}
        back={takeMeBackOnClick}
        imageAltText={intl.formatMessage({
          defaultMessage: "underwater glass"
        })}
        imageSrc="/images/illo-underwater-glass"
      />
      <Stack spacing="huge">
        <Text>
          <FormattedMessage
            defaultMessage="If you’re done, your Carrot Plan will disappear and you will not have access to funds or expert chats. You can
          get access again by requesting a new plan."
          />
        </Text>
        <CaseRateRenewalModalButtonGroup
          buttonOne={
            <Button variant="secondary" onClick={takeMeBackOnClick} disabled={isLoading}>
              <FormattedMessage defaultMessage="No, take me back" />
            </Button>
          }
          buttonTwo={
            <Button variant="primary" onClick={yesImDoneOnClick} disabled={isLoading}>
              <FormattedMessage defaultMessage="Yes, I'm done" />
            </Button>
          }
        />
      </Stack>
    </>
  )
}
